module.exports = __webpack_public_path__ + "static/zx_fjj-460ce4b0d6840827733075d67f6baa33.png";